








/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Vue from 'vue'

export default Vue.extend({
  name: 'PageHeader',
  props: {
    isSmall: {
      type: Boolean,
      default: () => false
    }
  },
  mounted () {
    const appTitle = this.$store.state.serviceName
    try {
      const pageTitle = ((this.$refs.title as HTMLElement).firstChild as ChildNode).textContent!.trim()
      const title = pageTitle ? `${pageTitle} : ${appTitle}` : appTitle
      document.title = title
    } catch {
      document.title = appTitle
    }
  }
})
